import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar/Sidebar';
import { Header } from './Header/Header';
import { usePrefetchDashboardData } from '@/hooks/usePrefetchDashboardData';

export function DashboardLayout() {
  // Prefetch critical dashboard data in background
  usePrefetchDashboardData();

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          {/* Suspense removido - já existe no App.tsx, evita flash branco duplicado */}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
